import { styled } from 'styled-components';

import { TagSize, TagVariant } from 'styled/components/Tag/Tag.types';
import { themed } from 'styled/helpers';

const StyledTag = styled.span<{
  $size: TagSize;
  $variant: TagVariant;
}>`
  text-transform: ${themed('component/tag/text/case')};
  border-radius: ${themed('component/tag/radius')};
  font-family: ${themed('component/tag/text/font')};
  font-weight: ${themed('component/tag/text/weight')};
  line-height: ${themed('component/tag/text/lineHeight')};
  background-color: ${({ $variant }) => themed(`component/tag/bg/color/${$variant}`)};
  color: ${({ $variant }) => themed(`component/tag/text/color/${$variant}`)};
  border-color: ${({ $variant }) => themed(`component/tag/border/color/${$variant}`)};
  border-width: ${({ $variant }) => themed(`component/tag/border/width/${$variant}`)};
  border-style: ${({ $variant }) => themed(`component/tag/border/style/${$variant}`)};
  font-size: ${({ $size }) => themed(`component/tag/text/size/${$size}`)};
  padding: ${({ $size }) => themed(`component/tag/padding/y/${$size}`)} ${({ $size }) => themed(`component/tag/padding/x/${$size}`)};
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  white-space: nowrap;
`;

export default StyledTag;
